import React from "react";
import "./Footer.css";
/* eslint-disable jsx-a11y/accessible-emoji */

export default function Footer(props) {
  return (
    <div className="footer-div">
      {/* <ToggleSwitch theme={props.theme} onToggle={props.onToggle}/> */}
    </div>
  );
}
